<template>
  <v-dialog
    :value="true"
    persistent
    max-width="500"
  >
    <v-card>
      <v-card-title class="d-block card-title">
        <template v-if="is === 'SignUpForm'">
          <h1 class="text-h5 mb-1">Đăng ký tài khoản</h1>
          <p class="text-caption mb-1">
            Đã có tài khoản?
            <span 
              class="vnr-link font-weight-bold"
              @click="is = 'SignInForm'"
            >Đăng nhập tại đây</span>
          </p>
        </template>
        <template v-else>
          <h1 class="text-h5 mb-1">Đăng nhập để sử dụng hệ thống</h1>
          <p class="text-caption mb-1">
            Chưa có tài khoản?
            <span 
              class="vnr-link font-weight-bold"
              @click="is = 'SignUpForm'"
            >Đăng ký tại đây</span>
          </p>
        </template>
      </v-card-title>
      <component :is="is"></component>
    </v-card>
  </v-dialog>
</template>

<script>
import SignUpForm from './SignUpForm.vue'
import SignInForm from './SignInForm.vue'

export default {
  name: 'Authen',

  data: () => ({
    is: 'SignInForm',
  }),

  components: {
    SignUpForm,
    SignInForm,
  },
}
</script>

<style scoped>
.card-title {
  background-color: var(--v-primary-lighten6);
}
</style>
